import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/service/api.service';
import { ApiData } from '../../shared/model/api-data.model';
import { ApiImage } from '../../shared/model/api-image.model';
import { ApiProduct } from '../../shared/model/api-product.model';
import { ApiGallery } from '../../shared/model/api-gallery.model';
import { ApiFunctionName } from '../../shared/enum/api-function-name.enum';
import { Lightbox } from 'ngx-lightbox';
import { createAlbum } from '../../api-utils';
import {
  copyMatchingKeyValues,
  getImageSized,
  getLoggedInUser,
  isLoggedIn,
  Loading,
  slugify,
} from '../../utils';
import { ApiDataService } from '../../shared/service/api-data.service';
import { ApiMenuGroup } from '../../shared/model/api-menu-group.model';
import { CartService } from '../../shared/service/cart.service';
import { LanguageService } from '../../shared/service/language.service';
import { ApiOrderItemFeature } from '../../shared/model/api.order-item-feature.model';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash';
import iziToast from 'izitoast';
import { replaceParams } from '../../shared/service/translations.service';
import { Bootbox } from '../../bootbox';
import { ApiMenu } from '../../shared/model/api-menu.model';
import { EventBroadcasterService } from '../../shared/service/event-broadcaster.service';
import { AppStorage, SessionAppStorage, StorageKey } from '../../storage';

declare var $: any;

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class IndexComponent implements OnInit {
  static readonly NUM_SLIDER_IMAGES = 3;
  static readonly NUM_GALLERY_IMAGES = 9;

  private galleryAlbum = [];

  selectedMenuName: string;
  pageImageUrl: string;
  apiData: ApiData;
  menu: { products: ApiProduct[]; currency: string };
  slider: ApiImage[] = [];
  gallery: ApiGallery[] = [];

  currency: string;
  menuGroups: ApiMenuGroup[] = [];
  products: ApiProduct[] = [];

  selectMenu: (index: number) => void;
  selectedMenuIndex = 0;

  isSmallScreen = false;

  selectedProduct: ApiProduct;
  selected_product_quantity: number = 1;
  selected_product_feature_price: number = 0;
  selected_product_feature_value: number = 1;

  isLoggedIn: boolean = false;
  onlineOrderDisable: boolean;

  customerMenus: ApiMenu[] = [];
  showMenuName: boolean = false;

  constructor(
    private apiService: ApiService,
    private apiDataService: ApiDataService,
    private cartService: CartService,
    private eventService: EventBroadcasterService,
    private languageService: LanguageService,
    private titleService: Title,
    private _lightbox: Lightbox
  ) {
    this.selectedProduct = new ApiProduct();
  }

  ngOnInit() {
    this.isLoggedIn = isLoggedIn();

    $('.modal').on('shown.bs.modal', (e) => {
      $(e.currentTarget).before($('.modal-backdrop'));
    });

    $('.category-navigation').on('click', (e) => {
      const that = $(e.currentTarget);
      const categoryWrapper = $('.category-wrapper');
      const direction = that.attr('data-direction');

      let directionAmount = categoryWrapper.width();

      if (direction === 'left') {
        directionAmount *= -1;
      }

      categoryWrapper.animate({ scrollLeft: `+=${directionAmount}` }, 750);
    });

    $('body').on('change', '.product-feature', () => {
      this.calculateSelectedFeatures();
    });

    this.apiService.apiData(ApiFunctionName.GetMenu).subscribe((apiData) => {
      this.apiData = apiData;

      this.onlineOrderDisable = apiData.Settings.WebSiteOrderMode !== 0;

      if (!this.isLoggedIn) {
        this.initializePage();
        return;
      }

      const user = getLoggedInUser();

      if (
        user.MenuID === null ||
        user.Menus === null ||
        user.Menus.length === 0
      ) {
        this.initializePage();
        return;
      }

      const selectedMenuId = SessionAppStorage.getItem(
        StorageKey.SELECTED_MENU_ID
      );
      if (selectedMenuId !== null) {
        user.MenuID = selectedMenuId;
      }

      Loading.show()
        .then(() => this.apiService.getMenuSummary())
        .then((menus: ApiMenu[]) => {
          this.customerMenus = menus;
        })
        .then(() => {
          let accountMenuIds = user.Menus.split(',').map((i) => parseInt(i));
          this.customerMenus = this.customerMenus.filter((i) =>
            accountMenuIds.includes(i.MenuID)
          );
        })
        .then(() => this.apiService.getMenu(user.MenuID))
        .then((menu: ApiMenu) => {
          this.apiData.Menu = menu;
          this.showMenuName = true;
        })
        .finally(() => {
          this.initializePage();
          Loading.hide();
        });
    });
  }

  initializePage() {
    this.slider = this.apiDataService.getSliderImages(
      IndexComponent.NUM_SLIDER_IMAGES
    );

    this.gallery = this.apiDataService.getGalleryImages(
      IndexComponent.NUM_GALLERY_IMAGES
    );
    this.galleryAlbum = createAlbum(this.gallery);

    this.currency = this.apiDataService.getCurrency();

    this.saveAppSettings(() => {
      this.setupProductsAndMenu();
    });

    this.titleService.setTitle(this.apiData.Title);
  }

  setupProductsAndMenu() {
    const menuGroups = (this.menuGroups = this.apiDataService.getMenuGroups());
    const appSettings = AppStorage.getItem(StorageKey.APP_SETTINGS) || {};
    const showClosed = appSettings.ShowClosed || 0;

    this.products = [];

    for (const menuGroup of menuGroups) {
      const slug = slugify(menuGroup.Name);

      menuGroup.selected = false;
      menuGroup.slug = slug;

      let filteredProducts = menuGroup.Products || [];

      if (showClosed === 1) {
        filteredProducts = filteredProducts.filter((p) => p.Status !== -1);
      }

      menuGroup.Products = filteredProducts;

      for (const product of menuGroup.Products) {
        product.slug = slug;

        if (!product.ImageUrl) {
          product.ImageUrl = this.apiData.ImageUrl;
          product.ImageUrl = getImageSized(product.ImageUrl, 400);
        }
      }

      this.products.push(...menuGroup.Products);
    }

    this.selectMenu = this.setSelected.bind(this, menuGroups);
    this.selectMenu(0);
  }

  setSelected(menuGroupArray: Array<{ selected: boolean }>, index: number) {
    if (menuGroupArray[this.selectedMenuIndex]) {
      menuGroupArray[this.selectedMenuIndex].selected = false;
    }
    if (menuGroupArray[index]) {
      menuGroupArray[index].selected = true;
    }

    this.selectedMenuIndex = index;
  }

  galleryLightbox(index: number) {
    this._lightbox.open(this.galleryAlbum, index);
  }

  onClickMenuGroup(index: number) {
    this.selectMenu(index);
    this.closeNav();
  }

  /**
   * Ürünün seçenek grubu (seçeneği) olup olmadığını kontrol eder.
   * Eğer showOptions === 0 ise seçenekler gizleneceği için butonu doğrudan "Sepete Ekle" yapmak adına false döndürüyoruz.
   */
  hasProductFeatures(product: ApiProduct): boolean {
    const appSettings = AppStorage.getItem(StorageKey.APP_SETTINGS) || {};
    const showOptionsVal = Number(appSettings.ShowOptions || appSettings.showOptions || 0);

    if (showOptionsVal === 0) {
      return false;
    }

    return !!(
      product &&
      product.ProductFeatureGroups &&
      product.ProductFeatureGroups.length > 0
    );
  }

  onClickProductAdd(product: ApiProduct) {
    const translations = this.languageService.translations;
    const that = this;

    const orderItem = new ApiProduct(product).createOrderItem();

    if (!this.cartService.canAddProduct(orderItem)) {
      iziToast.error({
        position: 'topRight',
        title: translations['general.error'],
        message: translations['general.cart_cant_add_diff_menu'],
      });
      return;
    }

    const appSettings = AppStorage.getItem(StorageKey.APP_SETTINGS) || {};
    const showOptionsVal = Number(appSettings.ShowOptions || appSettings.showOptions || 0);

    if (showOptionsVal === 0 || !this.hasProductFeatures(product)) {
      orderItem.Quantity = 1;
      orderItem.OrderItemFeatures = [];

      // ShowOptions 0 olsa bile default (varsayılan) özellikler varsa ekleyelim ki CartService fiyatı doğru hesaplasın
      if (showOptionsVal === 0 && product.ProductFeatureGroups && product.ProductFeatureGroups.length > 0) {
        for (const group of product.ProductFeatureGroups) {
          if (group.ProductFeature && group.ProductFeature.length > 0) {
            const defaultFeature = group.ProductFeature.find(
              (f: any) => f.Dafault === true || f.DefaultOption === true || f.Default === true || f.IsDefault === true
            );

            if (defaultFeature) {
              let orderItemFeature = new ApiOrderItemFeature();
              copyMatchingKeyValues(defaultFeature, orderItemFeature);
              orderItem.OrderItemFeatures.push(orderItemFeature);
            }
          }
        }
      }

      this.cartService.add(orderItem);

      iziToast.success({
        position: 'topRight',
        title: translations['general.success'],
        message: translations['general.item_added_to_cart'],
      });
      return;
    }

    Loading.show()
      .then(() => this.apiService.getProduct(product.ProductID))
      .then((productDetail: ApiProduct) => {
        that.selectedProduct = new ApiProduct(productDetail);

        if (showOptionsVal === 2 && this.selectedProduct.ProductFeatureGroups) {
          this.selectedProduct.ProductFeatureGroups = this.selectedProduct.ProductFeatureGroups.map((group: any) => {
            if (group.ProductFeature) {
              group.ProductFeature = group.ProductFeature.filter((f: any) => {
                return f.Dafault === true || f.DefaultOption === true || f.Default === true || f.IsDefault === true;
              });
            }
            return group;
          }).filter((group: any) => group.ProductFeature && group.ProductFeature.length > 0);
        }

        (product as any).displayPrice = this.calculateProductPrice(that.selectedProduct);

        for (let key in this.selectedProduct.ProductFeatureGroups) {
          if (!this.selectedProduct.ProductFeatureGroups.hasOwnProperty(key)) {
            continue;
          }

          const productGroup = this.selectedProduct.ProductFeatureGroups[key];
          productGroup.ProductFeatureChunk = _.chunk(
            productGroup.ProductFeature,
            2
          );
        }

        this.selected_product_quantity = 1;

        // @ts-ignore
        $('#productFeatureModal').modal('show');

        setTimeout(() => {
          this.initDefaultFeatures();
          this.calculateSelectedFeatures();
        }, 150);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (this.selectedProduct && this.selectedProduct.ProductFeatureGroups) {
          this.selectedProduct.ProductFeatureGroups.sort(
            (a, b) => (a.ViewIndex || 0) - (b.ViewIndex || 0)
          );
        }
        Loading.hide();
      });
  }

  initDefaultFeatures() {
    if (!this.selectedProduct || !this.selectedProduct.ProductFeatureGroups) return;

    this.selectedProduct.ProductFeatureGroups.forEach((group) => {
      if (group.ProductFeature && group.ProductFeature.length > 0) {
        const defaultFeature = group.ProductFeature.find(
          (f: any) => f.Dafault === true || f.DefaultOption === true || f.Default === true || f.IsDefault === true
        );

        if (defaultFeature) {
          const inputEl = $(`#item-${defaultFeature.ProductFeatureID}`);
          if (inputEl.length) {
            inputEl.prop('checked', true);
          }
        }
      }
    });

    this.calculateSelectedFeatures();
  }

  onClickAddToCartButton() {
    const translations = this.languageService.translations;

    const fqErr = this._checkFeaturesQuantity();

    if (fqErr !== null) {
      return;
    }

    const productObj: any = this.selectedProduct;
    if (!productObj) return;

    const orderItem = productObj.createOrderItem();

    const basePrice = parseFloat(productObj.Price || productObj.BasePrice || 0);
    orderItem.Quantity = this.selected_product_quantity || 1;
    orderItem.Price = basePrice;
    orderItem.UnitPrice = basePrice;

    const selectedFeatures = this._getSelectedFeatures();
    orderItem.OrderItemFeatures = selectedFeatures;

    let totalFeaturePrice = 0;
    let totalFeatureValue = 0;

    if (selectedFeatures && selectedFeatures.length > 0) {
      selectedFeatures.forEach((f: any) => {
        const price = parseFloat(f.Price) || 0;
        const value = parseFloat(f.Value) || 0;
        const isCountable = f.Countable === true || f.Countable === 1;

        if (!isCountable) {
          totalFeaturePrice += value > 0 ? value : price;
        } else {
          totalFeatureValue += price > 0 ? price : value;
        }
      });
    }

    orderItem.FeaturePrice = totalFeaturePrice;
    orderItem.FeatureValue = totalFeatureValue;

    const unitTotal = basePrice + totalFeaturePrice + totalFeatureValue;
    orderItem.TotalPrice = unitTotal * orderItem.Quantity;

    const result = this.cartService.add(orderItem);

    if (result === false) {
      return;
    }

    $('#productFeatureModal').modal('hide');
  }

  getImageSizedWrapper(input: string, size: number) {
    return getImageSized(input, size);
  }

  changeSelectedMenu(menu: ApiMenu) {
    SessionAppStorage.setItem(StorageKey.SELECTED_MENU_ID, menu.MenuID);
    window.location.reload();
  }

  _checkFeaturesQuantity() {
    const productObj: any = this.selectedProduct;

    if (!productObj || !productObj.ProductFeatureGroups || productObj.ProductFeatureGroups.length === 0) {
      return null;
    }

    let hasError = null;

    for (let fg of productObj.ProductFeatureGroups) {
      const group: any = fg;
      const features: any[] = group.ProductFeature;

      if (!features || features.length === 0) continue;

      for (let f of features) {
        const feature: any = f;
        const isChecked = $(`#item-${feature.ProductFeatureID}`).is(':checked');
        let selectedCount = isChecked ? 1 : 0;

        const minVal = parseFloat(feature.Min) || 0;
        const maxVal = parseFloat(feature.Max) || 0;

        if (minVal > 0 && selectedCount < minVal) {
          hasError = {
            FeatureGroup: group,
            Feature: feature,
            ShortAmount: minVal,
            Type: 0
          };
          break;
        }

        if (maxVal > 0 && selectedCount > maxVal) {
          hasError = {
            FeatureGroup: group,
            Feature: feature,
            ShortAmount: maxVal,
            Type: 1
          };
          break;
        }
      }

      if (hasError !== null) break;
    }

    return hasError;
  }

  _getSelectedFeatures() {
    let features: ApiOrderItemFeature[] = [];

    $('.feature-group-container').each((index: number, element: HTMLElement) => {
      let featureGroupId = parseInt($(element).attr('data-feature-group-id'));

      const productFeatureGroup = this.selectedProduct.ProductFeatureGroups
        .find((i) => i.ProductFeatureGroupID === featureGroupId);

      if (!productFeatureGroup) return;

      $(element).find('.product-feature:checked').each((index: number, element: HTMLElement) => {
        let featureId = parseInt($(element).attr('data-feature-id'));

        const feature = productFeatureGroup
          .ProductFeature
          .find((i) => i.ProductFeatureID === featureId);

        if (feature) {
          let orderItemFeature = new ApiOrderItemFeature();
          copyMatchingKeyValues(feature, orderItemFeature);
          features.push(orderItemFeature);
        }
      });
    });

    return features;
  }

  calculateSelectedFeatures() {
    this.selected_product_feature_price = 0;
    this.selected_product_feature_value = 1;

    $('#productFeatureModal .product-feature:checked').each((index, element) => {
      const el = $(element);
      const featurePrice = parseFloat(el.attr('data-feature-price') || '0');

      if (el.attr('data-feature-countable') == '0') {
        this.selected_product_feature_price += featurePrice;
      } else if (el.attr('data-feature-countable') == '1') {
        this.selected_product_feature_value = featurePrice;
      }
    });
  }

  calculateProductPrice(product: ApiProduct): number {
    if (!product) return 0;

    const basePrice = product.Price || 0;
    let defaultFeaturePrice = 0;

    if (product.ProductFeatureGroups && product.ProductFeatureGroups.length > 0) {
      for (const group of product.ProductFeatureGroups) {
        const categoryId = group.Category !== undefined ? group.Category : group.ProductFeatureGroupID;

        if (categoryId === 2 || categoryId === 15) {
          if (group.ProductFeature && group.ProductFeature.length > 0) {
            const defaultFeature: any = group.ProductFeature.find(
              (feature: any) => feature.DefaultOption === true || feature.Dafault === true || feature.Default === true
            );

            if (defaultFeature) {
              const price = parseFloat(defaultFeature.Price || 0);
              const value = parseFloat(defaultFeature.Value || 0);
              const isCountable = defaultFeature.Countable === true || defaultFeature.Countable === 1;

              if (!isCountable) {
                defaultFeaturePrice += value > 0 ? value : price;
              } else {
                defaultFeaturePrice += price > 0 ? price : value;
              }
            }
          }
        }
      }
    }

    return basePrice + defaultFeaturePrice;
  }

  toggleFeatureOption(feature: any, featureGroup: any, event: Event) {
    const target = event.target as HTMLElement;

    if (target.tagName.toLowerCase() === 'input') {
      this.calculateSelectedFeatures();
      return;
    }

    const inputEl = $(`#item-${feature.ProductFeatureID}`);
    if (!inputEl.length) return;

    if (featureGroup.Type !== 1 || feature.Countable) {
      $(`.product-feature[name="fg-${feature.ProductFeatureGroupID}"]`).prop('checked', false);
      inputEl.prop('checked', true);
    } else {
      const isChecked = inputEl.prop('checked');
      inputEl.prop('checked', !isChecked);
    }

    this.calculateSelectedFeatures();
  }

  closeNav() {
    document.getElementById('headerNav').style.marginLeft = '-100vw';
    document.getElementById('bg-left-menu').style.display = 'none';
  }

  saveAppSettings(callback?: () => void) {
    Loading.show()
      .then(() => this.apiService.getAppSettings(this.apiData.CustomerID, 7))
      .then((appSettingData: any) => {
        if (appSettingData && appSettingData.Settings) {
          const settings = typeof appSettingData.Settings === 'string'
            ? JSON.parse(appSettingData.Settings)
            : appSettingData.Settings;

          AppStorage.setItem(StorageKey.APP_SETTINGS, settings);
          localStorage.setItem('AppSetting', JSON.stringify(settings));
        }
      })
      .finally(() => {
        Loading.hide();
        if (callback) {
          callback();
        }
      });
  }
}
